var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"progressbar",style:('margin-left: ' + _vm.lengthProgressbar)},_vm._l((_vm.steps),function(i){return _c('li',{key:i.id,staticClass:"active",style:('width: ' + _vm.length)},[_vm._v(_vm._s(i.name))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }